import { asValidator as e, borderColorValidator as t, borderRadiusValidator as n, borderWidthValidator as r, layoutValidator as i, overflowValidator as a, scrollbarValidator as o, shadowValidator as s, spacingValidator as c, surfaceValidator as l } from "./validators.js";
import { computed as u, createBlock as d, createElementVNode as f, normalizeClass as p, onMounted as m, openBlock as h, renderSlot as g, resolveDirective as _, resolveDynamicComponent as v, withCtx as y, withDirectives as b } from "vue";
//#region components/box/box.vue
var x = /* @__PURE__ */ Object.assign({ name: "DtBox" }, {
	__name: "box",
	props: {
		as: {
			type: String,
			default: "div",
			validator: e
		},
		scrollbar: {
			type: [String, Boolean],
			default: void 0,
			validator: o
		},
		surface: {
			type: String,
			default: void 0,
			validator: l
		},
		borderColor: {
			type: String,
			default: "default",
			validator: t
		},
		borderRadius: {
			type: String,
			default: void 0,
			validator: n
		},
		borderWidth: {
			type: String,
			default: void 0,
			validator: r
		},
		borderWidthBlock: {
			type: String,
			default: void 0,
			validator: r
		},
		borderWidthBlockEnd: {
			type: String,
			default: void 0,
			validator: r
		},
		borderWidthBlockStart: {
			type: String,
			default: void 0,
			validator: r
		},
		borderWidthInline: {
			type: String,
			default: void 0,
			validator: r
		},
		borderWidthInlineEnd: {
			type: String,
			default: void 0,
			validator: r
		},
		borderWidthInlineStart: {
			type: String,
			default: void 0,
			validator: r
		},
		padding: {
			type: String,
			default: void 0,
			validator: c
		},
		paddingBlock: {
			type: String,
			default: void 0,
			validator: c
		},
		paddingBlockEnd: {
			type: String,
			default: void 0,
			validator: c
		},
		paddingBlockStart: {
			type: String,
			default: void 0,
			validator: c
		},
		paddingInline: {
			type: String,
			default: void 0,
			validator: c
		},
		paddingInlineEnd: {
			type: String,
			default: void 0,
			validator: c
		},
		paddingInlineStart: {
			type: String,
			default: void 0,
			validator: c
		},
		blockSize: {
			type: String,
			default: void 0,
			validator: i
		},
		inlineSize: {
			type: String,
			default: void 0,
			validator: i
		},
		maxBlockSize: {
			type: String,
			default: void 0,
			validator: i
		},
		minBlockSize: {
			type: String,
			default: void 0,
			validator: i
		},
		maxInlineSize: {
			type: String,
			default: void 0,
			validator: i
		},
		minInlineSize: {
			type: String,
			default: void 0,
			validator: i
		},
		shadow: {
			type: String,
			default: void 0,
			validator: s
		},
		overflow: {
			type: String,
			default: void 0,
			validator: a
		},
		scrollbarContentClass: {
			type: [
				String,
				Object,
				Array
			],
			default: ""
		}
	},
	setup(e) {
		let t = e, n = [
			"ul",
			"ol",
			"span",
			"fieldset"
		], r = u(() => t.scrollbar === !0 ? "leave" : t.scrollbar ?? void 0);
		m(() => {
			t.scrollbar && n.includes(t.as) && console.warn(`[DtBox] scrollbar prop inserts a <div> wrapper which breaks semantic child structure for <${t.as}>. Consider applying scrollbar on a parent DtBox container instead.`);
		});
		function i(e, t) {
			return t ? `${e}-${t}` : !1;
		}
		function a(e) {
			return [
				i("d-box--p", e.padding),
				i("d-box--pi", e.paddingInline),
				i("d-box--pis", e.paddingInlineStart),
				i("d-box--pie", e.paddingInlineEnd),
				i("d-box--pbl", e.paddingBlock),
				i("d-box--pbs", e.paddingBlockStart),
				i("d-box--pbe", e.paddingBlockEnd)
			];
		}
		function o(e) {
			return [
				i("d-box--surface", e.surface),
				i("d-box--bc", e.borderColor),
				i("d-box--bw", e.borderWidth),
				i("d-box--bwi", e.borderWidthInline),
				i("d-box--bwis", e.borderWidthInlineStart),
				i("d-box--bwie", e.borderWidthInlineEnd),
				i("d-box--bwbl", e.borderWidthBlock),
				i("d-box--bwbs", e.borderWidthBlockStart),
				i("d-box--bwbe", e.borderWidthBlockEnd),
				i("d-box--br", e.borderRadius),
				i("d-box--shadow", e.shadow),
				i("d-box--of", e.overflow)
			];
		}
		function s(e) {
			return [
				i("d-box--is", e.inlineSize),
				i("d-box--bls", e.blockSize),
				i("d-box--min-is", e.minInlineSize),
				i("d-box--max-is", e.maxInlineSize),
				i("d-box--min-bls", e.minBlockSize),
				i("d-box--max-bls", e.maxBlockSize)
			];
		}
		let c = u(() => [
			"d-box",
			...a(t),
			...o(t),
			...s(t)
		]);
		return (t, n) => {
			let i = _("dt-scrollbar");
			return e.scrollbar ? b((h(), d(v(e.as), {
				key: 0,
				"data-qa": "dt-box",
				class: p(c.value)
			}, {
				default: y(() => [f("div", {
					"data-qa": "dt-box-scrollbar-content",
					class: p(["d-box__scrollbar-content", e.scrollbarContentClass])
				}, [g(t.$slots, "default")], 2)]),
				_: 3
			}, 8, ["class"])), [[
				i,
				void 0,
				r.value
			]]) : (h(), d(v(e.as), {
				key: 1,
				"data-qa": "dt-box",
				class: p(c.value)
			}, {
				default: y(() => [g(t.$slots, "default")]),
				_: 3
			}, 8, ["class"]));
		};
	}
});
//#endregion
export { x as default };

//# sourceMappingURL=box.js.map